import {
  getCardInfo,
} from "@/api/payment2";

export default {
  namespaced: true,
  state: {
    cardList: [],
  },
  mutations: {
    SET_CARDLIST(state, payload) {
      state.cardList = [...payload.map(item => {
        return {
          ...item,
          service: item.logo,
          logo: {
            "American Express": require("@/assets/img/card/logo/american-express@2x.png"),
            "Diners Club": require("@/assets/img/card/logo/diners-club@2x.png"),
            Discover: require("@/assets/img/card/logo/discover@2x.png"),
            JCB: require("@/assets/img/card/logo/jcb@2x.png"),
            MasterCard: require("@/assets/img/card/logo/master-card@2x.png"),
            UnionPay: require("@/assets/img/card/logo/unionpay@2x.png"),
            Visa: require("@/assets/img/card/logo/visa@2x.png")
          }[item['logo']]
        }
      })];
    }
  },
  actions: {
    async getCardInfo({ commit }) {
      await getCardInfo().then((res) => {
        const data = res.data;
        commit("SET_CARDLIST", data);
      }).catch((error) => {
        Promise.reject(error);
      })
    }
  },
}
